<template>
	<!-- 单题统计 -->
	<div class="item-statistics">
		<div class="w1">
			<div class="flex space-between" style="margin-top: 30px">
				<p class="title_tj">{{$t('DataRecycling.DataOverview')}}</p>
				<!-- <span class="time">{{$t('DataRecycling.UpdatedOn')}}：{{ count.updateTime }}</span> -->
			</div>

			<ul class="tj_box flex">
				<li class="flex column align-items">
					<p>{{$t('DataRecycling.NewToday')}}</p>
					<span>{{ count.todayNewDate }}</span>
				</li>
				<li class="flex column align-items">
					<p>{{$t('DataRecycling.TotalDataVolume')}}</p>
					<span style="color: #0080ff">{{ count.allData }}</span>
				</li>
				<li class="flex column align-items">
					<p>{{$t('DataRecycling.AverageAnswerTime')}}</p>
					<span style="color: #33cc33">{{ count.averageAnswerTime }}</span>
				</li>
			</ul>

			<filtrate @loadfiltrate="loadfiltrate"></filtrate>

			<div class="flex space-between" style="margin-top: 30px"><p class="title_tj">{{$t('DataRecycling.TopicStatistics')}}</p></div>
			<!-- 数据展示 -->

			<div class="tx_box">
				<!-- 3/10 隐藏 原因导出文件过大服务器卡死  隐藏导出按钮-->
				<div class="flex flex-end" style="border-bottom: 1px solid #eee; padding-bottom: 15px">
					<el-button plain style="margin-top: 10px; margin-right: 10px" @click="setShowGraph">{{$t('DataRecycling.SetDisplay')}}</el-button>

					<el-button plain style="margin-top: 10px; margin-right: 10px" @click="centerDialogVisible = true">{{$t('DataRecycling.Export')}}</el-button>
					<!-- <el-button plain style="margin-top: 10px; margin-right: 10px" @click="centerDialogVisible = true">分享</el-button>
					<el-dropdown>
						<el-button plain style="margin-top: 10px; margin-right: 10px">
							更多
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>全屏</el-dropdown-item>
							<el-dropdown-item>打印</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->
				</div>
				<div v-for="(datasItem, datasIndex) in statisticsList" :key="datasIndex">
					<!-- 单选类型 , 下拉可切换展示饼图 柱状图 条形图 圆环 -->
					<div
						class="data"
						v-if="
							datasItem.questionsType == 11 ||
								datasItem.questionsType == 12 ||
								datasItem.questionsType == 29 ||
								datasItem.questionsType == 6 ||
								datasItem.questionsType == 8 ||
								datasItem.questionsType == 38
						"
					>
						<onechart :CrossTabs="datasItem"></onechart>
					</div>
					<!-- 多选类型 , 下拉可切换展示折线 柱形 条形 -->
					<div class="data" v-if="datasItem.questionsType == 10"><manychart :CrossTabs="datasItem"></manychart></div>

					<!-- 输入题型 只显示表格 填空-->
					<div
						class="data"
						v-if="
							datasItem.questionsType == 1 ||
								datasItem.questionsType == 13 ||
								datasItem.questionsType == 16 ||
								datasItem.questionsType == 17 ||
								datasItem.questionsType == 2 ||
								datasItem.questionsType == 22 ||
								datasItem.questionsType == 23 ||
								datasItem.questionsType == 28 ||
								datasItem.questionsType == 3 ||
								datasItem.questionsType == 30 ||
								datasItem.questionsType == 4 ||
								datasItem.questionsType == 5 ||
								datasItem.questionsType == 36||
								datasItem.questionsType == 39
						"
					>
						<div class="title_box">
							<span class="title_box_span">
								<span>{{ datasItem.sheet }}:</span>
								<span>{{ htmlToString(datasItem.name) }}</span>
							</span>
						</div>
						<div class="">
							<table border="1" v-if="datasItem.dataArrayList && datasItem.questionsType != 22 && datasItem.questionsType != 16 && datasItem.questionsType != 17 && datasItem.questionsType != 36&& datasItem.questionsType != 39">
								<tr>
									<td v-for="(item, index) in datasItem.dataArrayList[0].slice(0, datasItem.dataArrayList[0].length - 1)" :key="index">
										{{ htmlToString(item) }}
									</td>
									<td style="width:80px;text-align: center;padding-left: 0px;">{{$t('DataRecycling.Operate')}}</td>
								</tr>

								<tr v-for="(item, index) in datasItem.dataArrayList.slice(1)" :key="index">
									<td v-for="(item1, index1) in item.slice(0, item.length - 1)" :key="index1">{{ htmlToString(item1) }}</td>
									<td style="text-align: center;padding-left: 0px;">
										<el-button type="text" @click="dataPreview(item[item.length - 1])"><span>{{$t('DataRecycling.Preview')}}</span></el-button>
									</td>
								</tr>

								<tr>
									<td :colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange(val, datasItem.id, datasIndex, datasItem)"
											:page-size="10"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>

							<!-- 省市县 -->
							<table border="1" v-if="datasItem.dataArrayList && datasItem.questionsType == 16">
								<tr>
									<td v-for="(item, index) in datasItem.dataArrayList[0]" :key="index">{{ htmlToString(item) }}</td>
									<td style="width:80px;text-align: center;padding-left: 0px;">{{$t('DataRecycling.Operate')}}</td>
								</tr>

								<tr v-for="(item, index) in datasItem.dataArrayList.slice(1)" :key="index" class="table_tr">
									<td v-for="(item1, index1) in item" :key="index1">{{ htmlToString(item1) }}</td>
									<td style="width:80px;text-align: center;padding-left: 0px;">
										<el-button type="text" @click="dataPreview(item[item.length - 1][1])"><span>{{$t('DataRecycling.Preview')}}</span></el-button>
									</td>
								</tr>

								<tr>
									<td :colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange4(val, datasItem.id, datasIndex, datasItem)"
											:page-size="10"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>

							<!-- 矩阵填空 -->
							<table border="1" v-if="datasItem.dataArrayList && datasItem.questionsType == 22">
								<tr v-for="(item, index) in datasItem.dataArrayList" :key="index">
									<td v-for="(item1, index1) in item" :key="index1">{{ htmlToString(item[index1]) }}</td>
								</tr>
								<tr>
									<td colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange2(val, datasItem.id, datasIndex, datasItem)"
											:page-size="1"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>
							
							<!-- 矩阵填空 -->
							<table border="1" v-if="datasItem.dataArrayList && datasItem.questionsType == 39">
								<tr v-for="(item, index) in datasItem.dataArrayList" :key="index">
									<td v-for="(item1, index1) in item" :key="index1">{{ htmlToString(item[index1]) }}</td>
								</tr>
								<tr>
									<td colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange2(val, datasItem.id, datasIndex, datasItem)"
											:page-size="1"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>

							<!-- 时间 -->
							<table border="1" v-if="datasItem.dataArrayList && datasItem.questionsType == 17">
								<tr>
									<td v-for="(item, index) in datasItem.dataArrayList[0].slice(0, datasItem.dataArrayList[0].length - 1)" :key="index">
										{{ htmlToString(item) }}
									</td>
									<td style="width:80px;text-align: center;padding-left: 0px;">{{$t('DataRecycling.Operate')}}</td>
								</tr>

								<tr v-for="(item, index) in datasItem.dataArrayList.slice(1)" :key="index" class="table_tr">
									<td v-for="(item1, index1) in item.slice(0, item.length - 1)" :key="index1">{{ htmlToString(item1) }}</td>
									<td style="width:80px;text-align: center;padding-left: 0px;">
										<el-button type="text" @click="dataPreview(item[item.length - 1])"><span>{{$t('DataRecycling.Preview')}}</span></el-button>
									</td>
								</tr>
								<tr>
									<td colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange(val, datasItem.id, datasIndex, datasItem)"
											:page-size="10"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<!-- 多项填空 竖向排序 -->
					<div class="data" v-if="datasItem.questionsType == 34 || datasItem.questionsType == 35">
						<div class="title_box">
							<span class="title_box_span">
								<span>{{ datasItem.sheet }}:</span>
								<span>{{ htmlToString(datasItem.name) }}</span>
							</span>
						</div>
						<div class="">
							<table border="1" v-if="datasItem.dataArray">
								<tr>
									<td v-for="(item, index) in datasItem.dataArray[0].slice(0, datasItem.dataArray[0].length - 1)" :key="index">{{ htmlToString(item) }}</td>
									<td style="width:80px;text-align: center;padding-left: 0px;">{{$t('DataRecycling.Operate')}}</td>
								</tr>

								<tr v-for="(item, index) in datasItem.dataArray.slice(1)" :key="index">
									<td v-for="(item1, index1) in item.slice(0, item.length - 1)" :key="index1">{{ htmlToString(item1) }}</td>
									<td style="text-align: center; padding-left: 0px;">
										<el-button type="text" @click="dataPreview(item[item.length - 1])"><span>{{$t('DataRecycling.Preview')}}</span></el-button>
									</td>
								</tr>
								<tr>
									<td colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange(val, datasItem.id, datasIndex, datasItem)"
											:page-size="10"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>
						</div>
					</div>

					<!-- 排序题型 只显示折线 -->
					<div class="data" v-if="datasItem.questionsType == 14">
						<div class="title_box">
							<span class="title_box_span">
								<span>{{ datasItem.sheet }}:</span>
								<span>{{ htmlToString(datasItem.name) }}</span>
							</span>
						</div>

						<!-- <chart
							ref="chart1"
							id="main"
							:options="datasItem.options"
							:auto-resize="true"
							style=" width: 90%; height: 400px; margin: 0 auto; margin-top: 20px; "
						></chart> -->

						<div class="">
							<table border="1" v-if="datasItem.dataArrayList">
								<tr v-for="(item, index) in datasItem.dataArrayList" :key="index" class="table_tr">
									<td v-for="(item1, index1) in item" :key="index1">{{ htmlToString(item1) }}</td>
								</tr>
								<!-- <tr>
									<td>{{ datasItem.datas[datasItem.datas.length - 1][0] }}{{ datasItem.datas[datasItem.datas.length - 1][1] }}</td>
								</tr> -->
							</table>
						</div>
					</div>

					<!-- 地理位置 显示地图以及答题者所选中的地点 -->
					<div class="data" v-if="datasItem.questionsType == 15">
						<div class="title_box">
							<span class="title_box_span">
								<span>{{ datasItem.sheet }}:</span>
								<span>{{ htmlToString(datasItem.name) }}</span>
							</span>
						</div>
						<div class="answerPeopleNum">{{$t('DataRecycling.NumberOfRespondents')}}：{{ datasItem.dataList[0][0].length }}</div>
						<div class="mapData">
							<Map :id="'mapContainer-' + datasItem.id" :mapDatas="datasItem" style="height: 400px;" />
							<!-- <el-amap class="amap-box" :amap-manager="amapManager" :vid="'amap-vue'" :zoom="zoom" :plugin="plugin" :center="center" :events="events"></el-amap> -->
						</div>
					</div>

					<!-- 矩阵单选 切换显示堆积柱状图 堆积条形图 雷达图 -->
					<div class="data" v-if="datasItem.questionsType == 19"><matrixchart :CrossTabs="datasItem"></matrixchart></div>

					<!-- 矩阵打分题 切换显示折线图和雷达图 -->
					<div class="data" v-if="datasItem.questionsType == 21"><matrixScoreChart :CrossTabs="datasItem"></matrixScoreChart></div>

					<div class="data" v-if="datasItem.questionsType == 33">
						<div class="title_box">
							<span class="title_box_span">
								<span>{{ datasItem.sheet }}:</span>
								<span>{{ htmlToString(datasItem.name) }}</span>
							</span>
						</div>
						<div class="">
							<table border="1" v-if="datasItem.dataArrayList">
								<!-- <tr>  3/17 隐藏 未写接口
									<td><el-button :plain="true" @click="open2(datasItem)" class="right">下载全部附件</el-button></td>
								</tr> -->
								<!-- 文件上传 -->
								<tr v-for="(item, index) in datasItem.dataArrayList" :key="index" class="table_tr">
									<td v-for="(item1, index1) in item" :key="index1">{{ htmlToString(item1) }}</td>
									<td style="text-align: center; padding-left: 0px;">
										<el-button type="text" @click="openOne(item[item.length - 1])" v-if="index != 0">{{$t('DataRecycling.Download')}}</el-button>
										<el-button type="text" @click="ImgPreview(item[item.length - 1])" v-if="index != 0">{{$t('DataRecycling.Preview')}}</el-button>
									</td>
								</tr>
								<tr>
									<td colspan="100">
										{{$t('DataRecycling.NumberOfRespondents')}} : {{ datasItem.answerNumber }}
										<el-pagination
											class="right"
											@current-change="val => handleCurrentChange3(val, datasItem.id, datasIndex, datasItem)"
											:page-size="10"
											layout="prev, pager, next, jumper"
											:total="datasItem.answerNumber"
										></el-pagination>
									</td>
								</tr>
							</table>
						</div>

						<el-dialog :title="$t('DataRecycling.Preview')" :visible.sync="preview" width="30%" :before-close="handlePreviewClose" :close-on-click-modal="false">
							<p>
								{{ htmlToString(file.name) }}
								<a class="right" style="cursor:pointer;" @click="openOne(file.name)">{{$t('DataRecycling.Download')}}</a>
							</p>

							<el-image :src="url" fit="cover"></el-image>

							<span slot="footer" class="dialog-footer">
								<el-button size="medium" @click="preview = false">{{$t('main.cancel2')}}</el-button>
								<el-button size="medium" type="primary" @click="preview = false">{{$t('main.ok2')}}</el-button>
							</span>
						</el-dialog>
					</div>

					<!-- 矩阵多选 切换显示条形 柱形 雷达图 -->
					<div class="data" v-if="datasItem.questionsType == 20"><matrixchart :CrossTabs="datasItem"></matrixchart></div>

					<!-- 下拉框 可多选 可单选 -->
					<div class="data" v-if="datasItem.questionsType == 9"><onechart :CrossTabs="datasItem"></onechart></div>
				</div>
				<!-- 加载更多对话框 -->
				<el-button type="plain" :loading="btnloading" @click="loadMore" v-if="page < pageCount" class="loadMore">{{$t('DataRecycling.LoadMore')}}</el-button>
			</div>
		</div>
		<!-- 导出对话框 -->
		<el-dialog title="导出数据" :visible.sync="centerDialogVisible" width="40%" center :close-on-click-modal="false">
			<div style="margin-left: 30px; height: 150px; margin-top: 20px">
				<div class="flex align-items">
					<span style="margin-right: 20px">{{$t('DataRecycling.ExportType')}}</span>
					<el-radio-group v-model="radio" @change="aa">
						<!-- <el-radio :label="1" value="1">原始数据</el-radio> -->
						<el-radio :label="2" value="2">{{$t('DataRecycling.DataReport')}}</el-radio>
					</el-radio-group>
				</div>
				<div class="flex align-items" style="margin-top: 20px">
					<span style="margin-right: 20px">{{$t('DataRecycling.ExportFormat')}}</span>
					<el-radio-group v-model="radiodc" v-if="radio == 1" @change="csv">
						<el-radio :label="1" value="1">{{$t('DataRecycling.ExportCSV')}}</el-radio>
						<!-- <el-radio :label="2" value="2">导出SPSS</el-radio> -->
					</el-radio-group>
					<el-radio-group v-model="radiodc" v-if="radio == 2" @change="cel">
						<el-radio :label="1" value="1">{{$t('DataRecycling.ExportToExcel')}}</el-radio>
						<el-radio :label="2" value="2">{{$t('DataRecycling.ExportWord')}}</el-radio>
					</el-radio-group>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="centerDialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="exportExcl">{{$t('DataRecycling.Export')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div style="padding: 15px; text-indent: 2em"><span>{{$t('DataRecycling.ModifyQuestionnaireTip')}}</span></div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="handleConfirmClick">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
		<showGraphSet ref="showGraphSet" @chartDisplaySettingsOK="chartDisplaySettingsOK"></showGraphSet>
	</div>
</template>

<script>
import { AMapManager, lazyAMapApiLoaderInstance } from 'vue-amap';
import Map from '@/components/charts/map';
import onechart from '@/components/statisticsEcharCopy/oneChart';
import matrixchart from '@/components/statisticsEcharCopy/matrixChart';
import manychart from '@/components/statisticsEcharCopy/manyChart';
import matrixScoreChart from '@/components/statisticsEcharCopy/matrixScoreChart';
import showGraphSet from '@/components/itemStatisticsCopy/showGraphSet';
import filtrate from '@/page/filtrate';
let amapManager = new AMapManager();
// import echarts from 'echarts'
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/line';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';

// var mychart = echarts.init(document.getElementById('main'))
export default {
	name: 'itemStatisticsCopy',
	components: {
		Map,
		onechart,
		matrixchart,
		manychart,
		matrixScoreChart,
		filtrate,
		showGraphSet
	},
	data() {
		let self = this;
		return {
			tableDatawjid: [], //题的id
			pageCount: 0,
			btnloading: false,
			page: 1, // 数据总分页
			dataListID: '',
			center: [116.397428, 39.90923],
			zoom: 15,
			plugin: '',
			label: {
				content: this.$t('DataRecycling.CustomTitle'),
				offset: [10, 12]
			},
			file: {
				name: '',
				type: ''
			},
			url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
			preview: false, // 预览
			lnglats: [],
			amapManager,
			events: {
				init() {
					lazyAMapApiLoaderInstance.load().then(() => {
						self.initMap();
					});
				}
			},
			//map: '', //地图
			total: 1,
			centerDialogVisible: false,
			dialogVisible: false,
			next: null,
			statisticsList: [],
			count: {},
			orgOptions: {},
			wid: 0,
			radio: 2,
			radiodc: 1,
			value: '',
			tableData: [],
			options: [
				{
					value: '1',
					label: this.$t('DataRecycling.Pie')
				},
				{
					value: '2',
					label: this.$t('DataRecycling.Histogram')
				},
				{
					value: '3',
					label: this.$t('DataRecycling.BarChart')
				},
				{
					value: '4',
					label: this.$t('DataRecycling.Ring')
				}
			],

			value1: '',
			options2: [
				{
					value: '6',
					label: this.$t('DataRecycling.StackedBarChart')
				},
				{
					value: '7',
					label: this.$t('DataRecycling.StackedBarChart')
				},
				{
					value: '8',
					label: this.$t('DataRecycling.RadarChart')
				}
			],
			value2: '',

			value3: '',

			value4: '',
			//  title:'',
			map: '',
			screening: ''
		};
	},
	methods: {
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		chartDisplaySettingsOK() {
			this.statisticsList = [];
			this.loadTj();
		},
		setShowGraph() {
			this.$refs.showGraphSet.openSetShowGraph();
		},
		loadfiltrate(val) {
			console.log(val);
			this.screening = val;
			this.statisticsList = [];
			this.loadTj();
		},
		dataPreview(data) {
			// console.log(data)
			this.$router.replace({ path: '/Details', query: { id: data, type: 5 } });
		},
		openOne(data) {
			console.log('xiaz', data);
			// 下载单个
			window.open(data);
		},

		open3(itemid) {
			let id = this.wid;
			let questionsId = itemid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.downloadUploadFilesZip}?id=${id}&questionsId=${questionsId}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		// 分页
		handleCurrentChange4(val, dataListID, dataIndex, datasItem) {
			//城市选择
			let id = dataListID;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.siteQuestion}?id=${id}&page=${val}&orders=${datasItem.sheet}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.$set(that.statisticsList, dataIndex, res.resultBody);
					}
				}
			};
			this.$util.request(params);
		},
		handleCurrentChange3(val, dataListID, dataIndex, datasItem) {
			//文件上传
			let id = dataListID;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.uploadFilesQuestion}?id=${id}&page=${val}&orders=${datasItem.sheet}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.$set(that.statisticsList, dataIndex, res.resultBody);
					}
				}
			};
			this.$util.request(params);
		},
		handleCurrentChange2(val, dataListID, dataIndex, datasItem) {
			//矩阵填空
			let id = dataListID;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.matrixInputQuestion}?id=${id}&page=${val}&orders=${datasItem.sheet}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						that.$set(that.statisticsList, dataIndex, res.resultBody);
					}
				}
			};
			this.$util.request(params);
		},
		handleCurrentChange(val, dataListID, dataIndex, datasItem) {
			//填空题 统计下一页
			let id = dataListID;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.inputQuestion}?id=${id}&page=${val}&orders=${datasItem.sheet}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.$set(that.statisticsList, dataIndex, res.resultBody);
					}
				}
			};
			this.$util.request(params);
		},
		// 判断预览类型
		ImgPreview(val) {
			console.log('预览', val);
			let a = val.split('.');
			this.file.name = val;
			this.file.type = String(a[1]);

			if (a[1] == 'jpg' || a[1] == 'png') {
				this.url = val;
				this.preview = true;
			} else {
				this.url = ``;
				this.preview = false;
				window.open(`${val}`);
			}
		},
		handlePreviewClose(done) {
			done();
		},
		initMap() {
			console.log(this.lnglats);
			// let map = this.amapManager.getMap();
			// var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
			// //遍历生成多个标记点
			// for (var i = 0; i < this.lnglats.length; i++) {
			// 	console.log("地理位置",this.lnglats[i][0])
			// 	// console.log("地理位置",this.lnglats[i][1])
			// 	let positionArr = []
			// 	this.lnglats[i][0].map(item=>{
			// 		this.lnglats[i][1].map(val => {
			// 			positionArr.push([item,val])
			// 		})
			// 	})
			// 	console.log(positionArr)
			// 	let marker = new AMap.Marker({
			// 		position: that.center,
			// 		map: map
			// 	});
			// 	// marker.content = '我是第' + (i + 1) + '个Marker';
			// 	marker.on('click', markerClick);
			// 	marker.emit('click', { target: marker }); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
			// }
			// function markerClick(e) {
			// 	infoWindow.setContent(e.target.content);
			// 	infoWindow.open(map, e.target.getPosition());
			// }
			// map.setFitView();
		},
		aa() {},
		csv() {},
		cel() {},
		loadCount() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.querydataSurvey}?questionnaireId=${id}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.count = res.resultBody;
					} else {
						that.count = {};
					}
				}
			};
			this.$util.request(params);
		},

		// 导出
		exportExcl() {
			var id = this.wid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportChoice}?id=${id}&state=${this.radiodc == 1 ? 0 : 1}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
						that.centerDialogVisible = false;
					}
				}
			};
			this.$util.request(params);
		},
		loadMore() {
			this.page++;
			this.btnloading = true;
			this.loadTj();
		},
		drawChart() {
			//图表变换
			let that = this;
			for (let i = 0; i < that.statisticsList.length; i++) {
				console.log('图表', that.statisticsList[i]);

				let lab = [];
				let val = [];
				let ii = [];
				let chartType = 0;
				that.statisticsList[i].chartType = that.statisticsList[i].chartType + ''; //切换图标类型
				that.total = that.statisticsList[i].answerNumber;
				that.statisticsList[i].options = {};
				that.tableData = that.statisticsList[i].dataArrayList;
				that.tableDatawjid.push(that.statisticsList[i].id);
				// console.log('1111111',that.statisticsList[i])
				// that.lnglats = that.statisticsList[i].dataList;  //地图题
				if (
					that.statisticsList[i].questionsType == 20 ||
					that.statisticsList[i].questionsType == 19 ||
					that.statisticsList[i].questionsType == 21 ||
					that.statisticsList[i].questionsType == 22 ||
					that.statisticsList[i].questionsType == 11 ||
					that.statisticsList[i].questionsType == 16 ||
					that.statisticsList[i].questionsType == 38
				) {
					//二维数组
					// 城市选择 省市县 判断
					if (that.statisticsList[i].questionsType == 16) {
						if (that.statisticsList[i].chartType == 3) {
							that.statisticsList[i].chartType = 1;
						} else if (that.statisticsList[i].chartType == 2) {
							that.statisticsList[i].chartType = 2;
						} else if (that.statisticsList[i].chartType == 1) {
							that.statisticsList[i].chartType = 3;
						} else if (that.statisticsList[i].chartType == 0) {
							that.statisticsList[i].chartType = 4;
						}
					}
					that.tableData = that.statisticsList[i].dataList;
				}
				// 插件 图标绘制
				if (that.tableData) {
					if (
						that.statisticsList[i].questionsType == 20 ||
						that.statisticsList[i].questionsType == 19 ||
						that.statisticsList[i].questionsType == 21 ||
						that.statisticsList[i].questionsType == 22 ||
						that.statisticsList[i].questionsType == 15
					) {
						let targetArr = [];
						that.tableData.forEach((val, index) => {
							val.forEach((v, i) => {
								if (targetArr[i]) {
									targetArr[i].push(v);
								} else {
									targetArr[i] = [v];
								}
							});
						});

						targetArr.forEach((item, index) => {
							// console.log(item)
							// if (index !== 0 && index < that.tableData.length - 1) {
							lab.push(item[index][0]);
							val.push(item[index][1]);
							item.forEach((item1, index1) => {
								ii.push({ name: item1[0], number: item1[1] });
							});
							// }
						});
					}
					if (that.statisticsList[i].questionsType == 11 || that.statisticsList[i].questionsType == 38) {
						that.tableData.forEach((item, index) => {
							item.forEach((item1, index1) => {
								// console.log(item1)
								// console.log(index1)
								val.push(item[index1][1]);
								lab.push(item[index1][0]);
								ii.push(item);
							});
						});
					} else if (that.statisticsList[i].questionsType == 14) {
						for (let i = 1; i < that.tableData.length; i++) {
							lab.push(that.tableData[i][0]);
							let num = that.tableData[i][that.tableData[i].length - 1];
							ii.push(that.tableData[i]);
							val.push(num);
						}
						console.log(lab, val, ii);
					} else {
						that.tableData.forEach((item, index) => {
							// if (index !== 0 && index < that.tableData.length - 1) {
							val.push(item.number);
							lab.push(item.labelName);
							ii.push(item);
							// }
						});
					}
				}
				let title = that.statisticsList[i].name;

				if (that.statisticsList[i].chartType == 1) {
					let vall = [];
					if (that.statisticsList[i].questionsType != 11 && that.statisticsList[i].questionsType != 38) {
						ii.forEach((item, index) => {
							vall.push({ value: item.number, name: item.labelName });
						});
					} else {
						ii.forEach((item, index) => {
							vall.push({ value: item[index][1], name: item[index][0] });
						});
					}
					// var mychart = echarts.init()
					that.statisticsList[i].options = {
						title: {
							text: title,
							// subtext: '虚构数据',
							left: 'center'
						},
						toolbox: {
							show: true,
							feature: {
								saveAsImage: {
									show: true,
									excludeComponents: ['toolbox'],
									pixelRatio: 2
								}
							}
						},
						tooltip: {
							trigger: 'item',
							formatter: '{a} <br/>{b} : {c} ({d}%)'
						},
						series: [
							{
								name: that.$t('DataRecycling.Referrer'),
								type: 'pie',
								radius: '55%',
								center: ['50%', '60%'],
								data: vall,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								}
							}
						],
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2']
					};
				} else if (that.statisticsList[i].chartType == 2) {
					//柱状图
					chartType = 'bar';
					that.statisticsList[i].options = {
						title: {
							text: title,
							// subtext: '虚构数据',
							left: 'center'
						},
						toolbox: {
							show: true,
							feature: {
								saveAsImage: {
									show: true,
									excludeComponents: ['toolbox'],
									pixelRatio: 2
								}
							}
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						},
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
						xAxis: {
							type: 'category',
							data: lab
						},
						yAxis: {
							type: 'value'
						},
						series: [
							{
								data: val,
								type: chartType,
								smooth: true,
								barWidth: 30
							}
						]
					};
				} else if (that.statisticsList[i].chartType == 3) {
					// 条性图
					that.statisticsList[i].options = {
						title: {
							text: title,
							// subtext: '虚构数据',
							left: 'center'
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: {
							type: 'value',
							boundaryGap: [0, 0.01]
						},
						yAxis: {
							type: 'category',
							data: lab
						},
						series: [
							{
								type: 'bar',
								data: val,
								barWidth: 30
							}
						]
					};
				} else if (that.statisticsList[i].chartType == 4) {
					// 饼图 圆环
					chartType = 'pie';
					let vall = [];
					let name = [];
					if (that.statisticsList[i].questionsType != 11 && that.statisticsList[i].questionsType != 38) {
						ii.forEach((item, index) => {
							vall.push({ value: item.number, name: item.labelName });
							name.push(item.number);
						});
					} else {
						ii.forEach((item, index) => {
							vall.push({ value: item[index][1], name: item[index][0] });
							name.push(item[index][0]);
						});
					}
					that.statisticsList[i].options = {
						title: {
							text: title,
							// subtext: '虚构数据',
							left: 'center'
						},
						tooltip: {
							trigger: 'item',
							formatter: '{a} <br/>{b} : {c} ({d}%)'
						},
						legend: {
							orient: 'vertical',
							left: 10,
							data: name
						},
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
						series: [
							{
								type: 'pie',
								radius: ['50%', '70%'],
								avoidLabelOverlap: false,
								label: {
									show: false,
									position: 'center'
								},
								emphasis: {
									label: {
										show: true,
										fontSize: '30',
										fontWeight: 'bold'
									}
								},
								labelLine: {
									show: false
								},
								data: vall
							}
						]
					};
				} else if (that.statisticsList[i].chartType == 5 || that.statisticsList[i].questionsType == 14 || that.statisticsList[i].questionsType == 10) {
					// 折线是5
					chartType = 'line';
					that.statisticsList[i].options = {
						title: {
							text: that.htmlToString(title),
							// subtext: '虚构数据',
							left: 'center'
						},
						xAxis: {
							type: 'category',
							data: lab
						},
						yAxis: {
							type: 'value'
						},
						series: [
							{
								data: val,
								type: 'line'
							}
						],
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2']
					};
				} else if (that.statisticsList[i].chartType == 6) {
					// 堆叠柱状图
					chartType = 'bar';
					let neme1 = [];
					let data1 = [];
					let ll = that.statisticsList[i].questionsList;
					ll.forEach((item, index) => {
						neme1.push(item.questionsName);
					});
					// data1 = that.unique(ii,'name',"number")
					let newList = [];
					ii.forEach(item => {
						if (newList.length > 0) {
							let titleStr = [];
							newList.forEach(ele => {
								titleStr.push(ele.title);
							});
							if (titleStr.indexOf(item.name) > -1) {
								newList[titleStr.indexOf(item.name)].data.push(item.number);
							} else {
								newList.push({
									title: item.name,
									data: [item.number],
									type: 'bar'
								});
							}
						} else {
							newList.push({
								title: item.name,
								data: [item.number],
								type: 'bar'
							});
						}
					});
					data1 = newList;
					that.statisticsList[i].options = {
						title: {
							// 名称
							text: title,
							// subtext: '虚构数据',
							left: 'center'
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								// 坐标轴指示器，坐标轴触发有效
								type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
							}
						},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: [
							{
								type: 'category',
								data: neme1
							}
						],
						yAxis: [
							{
								type: 'value'
							}
						],
						series: data1,
						barWidth: 30,
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2']
					};
				} else if (that.statisticsList[i].chartType == 7) {
					// 堆叠条形图
					chartType = 'bar';
					let neme1 = [];
					let data1 = [];
					let ll = that.statisticsList[i].questionsList;
					ll.forEach((item, index) => {
						neme1.push(item.questionsName);
					});
					// data1 = that.unique(ii,'name',"number")
					let newList = [];
					ii.forEach(item => {
						if (newList.length > 0) {
							let titleStr = [];
							newList.forEach(ele => {
								titleStr.push(ele.title);
							});
							if (titleStr.indexOf(item.name) > -1) {
								newList[titleStr.indexOf(item.name)].data.push(item.number);
							} else {
								newList.push({
									title: item.name,
									data: [item.number],
									type: 'bar'
								});
							}
						} else {
							newList.push({
								title: item.name,
								data: [item.number],
								type: 'bar'
							});
						}
					});
					data1 = newList;
					that.statisticsList[i].options = {
						title: {
							text: title,
							left: 'center'
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								// 坐标轴指示器，坐标轴触发有效
								type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
							}
						},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: {
							type: 'value'
						},
						yAxis: {
							type: 'category',
							data: neme1
						},
						series: data1,
						barWidth: 30,
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2']
					};
				} else if (that.statisticsList[i].chartType == 8) {
					// 雷达图
					chartType = 'radar';
					let neme1 = [];
					let data1 = [];
					let ll = that.statisticsList[i].questionsList;
					ll.forEach((item, index) => {
						neme1.push(item.questionsName);
					});
					// data1 = that.unique(ii,'name',"number")
					let newList = [];
					ii.forEach(item => {
						if (newList.length > 0) {
							let titleStr = [];
							newList.forEach(ele => {
								titleStr.push(ele.title);
							});
							if (titleStr.indexOf(item.name) > -1) {
								newList[titleStr.indexOf(item.name)].data.push(item.number);
							} else {
								newList.push({
									title: item.name,
									data: [item.number],
									type: 'radar'
								});
							}
						} else {
							newList.push({
								title: item.name,
								data: [item.number],
								type: 'radar'
							});
						}
					});
					data1 = newList;
					that.statisticsList[i].options = {
						title: {
							text: title
						},
						tooltip: {
							trigger: 'axis'
						},
						legend: {
							left: 'center'
							// data: ['某软件', '某主食手机', '某水果手机', '降水量', '蒸发量']
						},
						radar: [
							{
								indicator: neme1,
								center: ['25%', '40%'],
								radius: 80
							}
						],
						series: [
							{
								type: 'radar',
								areaStyle: {},
								data: data1
							}
						]
					};
				}
			}

			this.$forceUpdate();
		},
		//统计
		loadTj() {
			let that = this;
			let id = that.wid;
			let page = that.page;
			let tempScreening = {
				id: id,
				page: page
			};
			if (that.screening != '') {
				tempScreening = JSON.parse(that.screening);
				tempScreening.id = id;
				tempScreening.page = page;
			}
			let params = {
				that: this,
				url: `${this.$config.service.customDataStatistics}`,
				method: 'POST',
				data: tempScreening,
				cb(res) {
					if (res.code == 0) {
						that.pageCount = res.resultBody.pageCount; //伪分页
						for (let n = 0; n < res.resultBody.questionStatisticsVOS.length; n++) {
							console.log(res.resultBody.questionStatisticsVOS[n]);
							if (res.resultBody.questionStatisticsVOS[n] != '') {
								res.resultBody.questionStatisticsVOS[n].isbank = 0;
								that.statisticsList.push(res.resultBody.questionStatisticsVOS[n]);
							}
						}
						that.drawChart(); //调用图表
						that.btnloading = false;
						// push表格
					} else {
						that.statisticsList = [];
					}
				}
			};
			this.$util.request(params);
		},
		handleClick() {
			alert('button click');
		},
		handleClose() {
			this.dialogVisible = false;
		},
		handleConfirmClick() {
			this.dialogVisible = false;
			this.wid = sessionStorage.getItem('wid') || 0;
			this.$api.UpdateQuestionnaireState({ id: this.wid, state: 1 });
			this.next();
		}
	},
	mounted: function() {
		// let that = this;
		this.wid = sessionStorage.getItem('wid') || this.$route.query.wid || 0;
		this.loadTj();
		this.loadCount();
		// this.carGPSIP();
		// this.initMap();
		// console.log(this.lnglats)
	},
	beforeRouteLeave(to, from, next) {
		// 导航离开该组件的对应路由时调用
		// 可以访问组件实例 `this`
		if (to.name != 'QuestionType') {
			next();
		} else {
			let state = sessionStorage.getItem('wstate');
			if (state && state != 1) {
				this.next = next;
				this.dialogVisible = true;
			} else {
				next();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.item-statistics {
	height: 100vh;
	table {
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dbdada;
		margin-bottom: 20px;
		border-collapse: collapse;
		border-spacing: 0;
		margin-top: 20px;
	}

	table tr td {
		padding: 8px 0 8px 10px;
	}
	.table_tr:first-child(td) {
		background-color: #f9fcff;
	}
	.loadMore {
		margin: 20px auto;
		position: relative;
		left: 45%;
	}
	.data {
		// width: 1160px;
		height: auto;
		margin: 0 auto;
		border-bottom: 1px solid #e1e1e1;
		// margin-top: 30px;
		.mapData {
			// width: 1200px;
			height: 400px;
			position: relative;
			margin: 20px 20px;
			margin-top: 0px;
		}
		#container {
			width: 100%;
			height: 100%;
		}
		#test-map {
			width: 100%;
			height: 100%;
		}
	}
	.title_box {
		width: 100%;
		height: 56px;
		line-height: 56px;
		background: #f9fcff;
	}
	.title_box_span {
		margin-left: 25px;
		font-size: 14px;
		color: #000;
		font-family: Microsoft YaHei;
	}
	.el-dropdown {
		vertical-align: top;
	}
	.el-dropdown + .el-dropdown {
		margin-left: 15px;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
	.el-dropdown_button {
		float: right;
		margin-right: 20px;
	}
	/deep/ .el-input--suffix .el-input__inner {
		width: 120px !important;
	}

	.dt-title {
		text-align: center;
		margin-top: 20px;
		font-size: 16px;
	}
	.tx_box {
		width: 100%;
		min-height: 300px;
		margin-top: 30px;
		padding-bottom: 20px;
		background: #fff;
		box-shadow: 1px 3px 17px -5px #aeaeae;
	}
	.tj_box li {
		flex: 1;
		height: 100%;
		border-right: 1px solid #ccc;
	}
	.tj_box li p {
		font-size: 16px;
		color: #333;
		margin-bottom: 20px;
	}
	.tj_box li span {
		font-size: 20px;
		color: red;
	}
	.tj_box li:last-child {
		border-right: 0;
	}
	.tj_box {
		width: 100%;
		height: 80px;
		background: #fff;
		box-shadow: 1px 3px 17px -5px #aeaeae;
		margin-top: 30px;
		padding: 20px 0;
	}
	.title_tj {
		font-size: 18px;
	}
	.time {
		font-size: 14px;
		color: #666;
	}

	.display_inline {
		display: inline;
		float: left;
	}

	.el-header,
	.el-footer {
		color: #333;
		text-align: center;
		line-height: 60px;

		padding: 0px;
	}

	.el-aside {
		display: inline;
		float: left;
		background-color: #fff;
		color: #333;
		text-align: center;
		line-height: 200px;
		width: 300px !important;
	}

	.el-main {
		display: inline;
		float: left;
		background-color: #f3f5f6;
	}

	.el-container {
		margin-bottom: 40px;
	}

	.el-container:nth-child(5) .el-aside,
	.el-container:nth-child(6) .el-aside {
		line-height: 260px;
	}

	.el-container:nth-child(7) .el-aside {
		line-height: 320px;
	}

	.el-collapse-item__header {
		padding-left: 6px !important;
		font-weight: 800 !important;
	}

	.askitem {
		width: 32%;
		height: 80px;
		margin: 1px;
		cursor: pointer;
	}

	.type-item-icon {
		height: 50px;
		line-height: 86px;
		text-align: center;
	}

	.type-item-title {
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 8px;
	}

	.item_container {
		margin-top: 8px;
		background-color: #fff;
		margin-left: 0px !important;
		margin-right: 0px !important;
		padding-top: 6px;
		padding-bottom: 6px;
	}

	.item_container_hover {
		border: 2px #409eff solid;
		border-radius: 3px;
	}

	.el-input__inner {
		border: 0px;
		border-radius: 0;
		padding-left: 5px;
		padding-right: 5px;
	}

	.el-input__inner:hover {
		background-color: #aaa;
	}

	.operate_td {
		width: 30px;
		height: 30px;
		font-size: 26px;
		background-color: cornflowerblue;
		text-align: center;
		line-height: 30px;
	}

	.el-tooltip {
		padding-top: 0px !important;
	}

	.el-menu-item {
		margin-left: 0px !important;
	}

	.ck-content {
		min-height: 200px;
	}

	.el-divider--horizontal {
		margin: 0px !important;
	}

	.operate_item {
		height: 60px;
		line-height: 60px;
		width: 90%;
		margin: 0px auto;
	}

	.ck-editor__editable_inline {
		min-height: 200px;
	}

	.el-collapse-item__header {
		margin-left: 13px;
		font-weight: bold;
	}

	.wjTitle > input {
		border: 0px !important;
		text-align: center;
	}

	input {
		border: 0px !important;
	}

	input:hover {
		border: 1px #aaa dashed !important;
	}

	.option_input > input {
		height: 35px !important;
		line-height: 35px !important;
		border: 1px #aaa solid !important;
	}

	.option_input > input:hover {
		height: 35px !important;
		line-height: 35px !important;
		border: 1px #aaa solid !important;
	}

	.left {
		float: left;
		margin-left: 6px;
	}

	.right {
		float: right;
	}

	.el-dialog__body {
		padding: 0px 7px !important;
		color: #606266 !important;
		font-size: 14px !important;
		word-break: break-all !important;
	}

	.el-submenu__title {
		text-align: left !important;
	}
}
.answerPeopleNum {
	padding: 10px 0;
	font-size: 12px;
	text-align: center;
}
</style>
